import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SpinnerStatus } from 'src/app/_models/SpinnerStatus';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
})
export class SpinnerComponent implements OnInit {
  // @Input() loading: boolean;
  showSpinner = false;

  constructor(
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.init();
  }

  init(): void {
    this.spinnerService.getSpinnerObservable$().subscribe((status: number) => {
      this.showSpinner = status === SpinnerStatus.START;
      this.cdRef.detectChanges();
    });
  }
}
